exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-163b550f]:hover {\n  color: #0069d1;\n  transition: all .1s;\n}\n", ""]);

// exports
